"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppStore = void 0;
var store_1 = require("./store");
Object.defineProperty(exports, "createAppStore", { enumerable: true, get: function () { return store_1.createAppStore; } });
